import script from "./ServerContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerContent.vue?vue&type=script&setup=true&lang=js"

import "./ServerContent.vue?vue&type=style&index=0&id=6fd3ad88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd3ad88"]])

export default __exports__